import React from 'react';
import Loader from 'react-loader-spinner';
import { theme } from '../config/Theme';

const Spinner = (): JSX.Element => <Loader type='ThreeDots' color={theme.color.primary} height={100} width={100} />;

export default Spinner;
